var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M12 4c-3.303 0-6 2.542-6 6.5 0 2.784 1.872 5.962 5.658 9.509a.5.5 0 0 0 .684 0C16.128 16.462 18 13.284 18 10.5 18 6.542 15.303 4 12 4zm0-1c3.842 0 7 2.976 7 7.5 0 3.115-2.006 6.52-5.974 10.239a1.5 1.5 0 0 1-2.052 0C7.006 17.02 5 13.615 5 10.5 5 5.976 8.158 3 12 3zm0 10.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm0-1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" })
  );
});